import { Injectable, inject } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslocoService } from "@jsverse/transloco";
import { first } from "rxjs/operators";

const ITEMS_PER_PAGE_KEY = "paginator.items_per_page";
const NEXT_PAGE_KEY = "paginator.next_page";
const PREV_PAGE_KEY = "paginator.prev_page";
const FIRST_PAGE_KEY = "paginator.first_page";
const LAST_PAGE_KEY = "paginator.last_page";
const OUT_OF_KEY = "paginator.out_of";

@Injectable({
  providedIn: "root",
})
export class LorenMatPaginatorIntlService extends MatPaginatorIntl {
  private translate = inject(TranslocoService);

  outOfLabel: "/";

  public constructor() {
    super();
    // TODO refactor this
    this.translate.langChanges$.subscribe(() => {
      this.getAndInitTranslations();
    });

    this.getAndInitTranslations();
  }

  public getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.outOfLabel} ${length}`;
    }

    length = Math.max(length, 0);

    return `${this.translate.translate("paginator.page")} ${page + 1}  ${
      this.outOfLabel
    } ${Math.ceil(length / pageSize)}`;
  };

  public getAndInitTranslations(): void {
    this.translate
      .selectTranslate([
        ITEMS_PER_PAGE_KEY,
        NEXT_PAGE_KEY,
        PREV_PAGE_KEY,
        FIRST_PAGE_KEY,
        LAST_PAGE_KEY,
        OUT_OF_KEY,
      ])
      .pipe(first())
      .subscribe((translation) => {
        this.itemsPerPageLabel = translation[0];
        this.nextPageLabel = translation[1];
        this.previousPageLabel = translation[2];
        this.firstPageLabel = translation[3];
        this.lastPageLabel = translation[4];
        this.outOfLabel = translation[5];

        this.changes.next();
      });
  }
}
